import { useFeatureToggle } from "@aurumsoftware/hooks";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { isCollaboratorState } from "../../selectors/userInfoSelectors";
import { CalendarActivityTypes } from "@customTypes/filter";

const useCalendarActivityTypes = (withAllCalendarActivityTypes = false) => {
  const [calendarActivityTypes, setCalendarActivityTypes] = useState<CalendarActivityTypes[]>([
    "APPOINTMENT",
    "TASK",
  ]);
  const isCollaborator = useSelector(isCollaboratorState);

  const hasHearing = useFeatureToggle("hearing");
  const hasDeadline = useFeatureToggle("deadline");

  useEffect(() => {
    if (!isCollaborator) {
      if (hasHearing) setCalendarActivityTypes((prev) => ["HEARING", ...prev]);
      if (hasDeadline) setCalendarActivityTypes((prev) => ["DEADLINE", ...prev]);
    }
    if (withAllCalendarActivityTypes) setCalendarActivityTypes((prev) => [...prev, "ALL"]);
  }, [isCollaborator, hasHearing, hasDeadline, withAllCalendarActivityTypes]);

  return calendarActivityTypes;
};

export default useCalendarActivityTypes;
